import mixpanel from 'mixpanel-browser';
mixpanel.init(
  'b15c3b95e24948f3eef7719677eb888c',
  { 
    debug: true,
    persistence: "localStorage",
    ignore_dnt: true,
  }
);

let env_check = process.env.REACT_APP_ENV === 'prod';
// let env_check = true; // Consider not tracking data on staging

let actions = {
  identify: (id) => {
    if (env_check) mixpanel.identify(id);
    console.log('[Tracking]', id)
  },
  alias: (id) => {
    if (env_check) mixpanel.alias(id);
    console.log('[Tracking]', id)
  },
  track: (name, props) => {
    if (env_check) mixpanel.track(name, props);
    console.log('[Tracking]', name, props)
  },
  people: {
    set: (props) => {
      if (env_check) mixpanel.people.set(props);
      console.log('[Tracking]', props)
    },
  },
};

export let Tracking = actions;